import React from 'react';
import { connect } from 'react-redux';
import { DefaultButton, MessageBarType, Panel, PanelType, PrimaryButton, Separator, Spinner, SpinnerSize, Text, Toggle } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { useBoolean } from '@fluentui/react-hooks';

// styles 
import './PractitionerSettingsForm.Styles.css';

// i18next
import { Trans, useTranslation } from 'react-i18next';

// functions
import * as ComponentFunctions from './PractitionerSettingsForm.Functions';

// components
import ContractsSelectorComponent from '../../../../commons/component/Inputs/ContractSelector/ContractSelectorComponent';
import ProtocolContractFormComponent from '../../../Contracts/Protocols/ProtocolContractForm/ProtocolContractFormComponent';
import { MessageComponent } from '../../../../commons/component/MessageComponent';
import PractitionerConceptsListComponent from '../PracititionerConceptsList/PractitionerConcepts.List.Component';

// models
import { Contract } from '../../../../models/Entities/Contracts/Contract';
import { ContractCommissionAgent } from '../../../../models/Entities/Contracts/ContractCommissionAgent';
import { NewContractCommissionAgent } from '../../../../models/Entities/Contracts/NewContractCommissionAgent';
import { CommissionAgentTypeEnum } from '../../../../models/Entities/Contracts/CommissionAgentType';

const PractitionerSettingsForm = (props: ComponentFunctions.Props) => {

    // useTranslation()
    const [t] = useTranslation();

    const [submittedForm, setSubmittedForm] = useState<boolean>(false);
    const [hasSeenLoadingState, setHasSeenLoadingState] = useState<boolean>(false);

    // useEffect(() => {
    //     props.GetAllContracts();
    // }, []);

    useEffect(() => {
        
        if (props.isOpen && !props.isLoadingAgents && props.AgentsLoaded && props.Agent?.id === undefined) {

            //alert('create agent');

            var NewAgent: NewContractCommissionAgent = {
                contractId: props.ContractId,
                commissionAgentId: props.Practitioner.practitionerUserId,
                commissionAgentName: props.GetPractiontioner(props.Practitioner.practitionerUserId)?.fullName,
                currency: 'USD',
                commissionAmount: 0,
                contractAssociatedId: undefined,
                haveContractAssociated: false,
                isCommissionAPercentage: true,
                onlyDoneHimSelf: false,
                // Este formulario es el del equipo del protocolo: lo que da de alta
                // es siempre un profesional.
                commissionAgentType: CommissionAgentTypeEnum.Practitioner
            } as NewContractCommissionAgent;

            props.CreateContractCommissionAgent(NewAgent);

        }

    }, [props.isOpen === true && props.Agent === undefined]);

    useEffect(() => {
        if (props.Agent) {
            setPayFixValue(!props.Agent.isCommissionAPercentage);
            setFixValue(props.Agent.commissionAmount);
            setCurrency(props.Agent.currency);
            setPercentage(props.Agent.commissionAmount);
            setHaveContractAssociated(props.Agent.haveContractAssociated);
            setContractId(props.Agent.contractAssociatedId);
            setOnlyMadeByHimSelf(props.Agent.onlyDoneHimSelf);
        }

    }, [props.Practitioner?.practitionerUserId, props.Agent?.id]);

    useEffect(() => {
        console.log('Estados cambiaron:');
        console.log('- submittedForm:', submittedForm);
        console.log('- isSaving:', props.isSaving);
        console.log('- isUpdating:', props.isUpdating);
        console.log('- isSavedSuccessfully:', props.isSavedSuccessfully);
        console.log('- isUpdatedSuccessfully:', props.isUpdatedSuccessfully);
        
        // Trackear cuando vemos el estado de loading
        if (submittedForm && (props.isSaving || props.isUpdating)) {
            console.log('Vimos el estado de loading!');
            setHasSeenLoadingState(true);
        }
    }, [submittedForm, props.isSaving, props.isUpdating, props.isSavedSuccessfully, props.isUpdatedSuccessfully]);

    useEffect(() => {
        // Solo auto-cerrar si vimos el loading state
        if (submittedForm && hasSeenLoadingState && (props.isSavedSuccessfully || props.isUpdatedSuccessfully)) {
            console.log('Auto-cerrando formulario (vimos loading)');
            setSubmittedForm(false);
            setHasSeenLoadingState(false);
            props.dismissPanel();
        }
    }, [submittedForm, hasSeenLoadingState, props.isSavedSuccessfully, props.isUpdatedSuccessfully]);

    const [isOpenContractPanel, { setTrue: openContractPanel, setFalse: dismissContractPanel }] =
        useBoolean(false);

    
    // internal marks
    const [payFixValue, setPayFixValue] = useState<boolean>(true);
    const [paySimple, setPaySimple] = useState<boolean>(false);
    const [payByConcept, setPayByConcept] = useState<boolean>(false);

    const [FixValue, setFixValue] = useState<number>(0);
    const [Currency, setCurrency] = useState<string>();
    const [Percentage, setPercentage] = useState<number>(0);
    const [haveContractAssociated, setHaveContractAssociated] = useState<boolean>(false);
    const [ContractId, setContractId] = useState<number>();
    const [onlyMadeByHimSelf, setOnlyMadeByHimSelf] = useState<boolean>(false);
    const [discountAlreadyPaidToSI, setDiscountAlreadyPaidToSI] = useState<boolean>(false);

    const ResetForm = () => {
        setPayFixValue(true);
        setFixValue(0);
        setCurrency(undefined);
        setPercentage(0);
        setHaveContractAssociated(false);
        setContractId(undefined);
        setOnlyMadeByHimSelf(false);

    };


    const HandleCancelForm = () => {
        //ResetForm();
        props.dismissPanel();
    };


    // events
    const HandleSaveForm = () => {
        console.log('HandleSaveForm ejecutado');
        console.log('props.isSaving:', props.isSaving);
        console.log('props.isUpdating:', props.isUpdating);

        setSubmittedForm(true);

        var currentCommissionAgent: NewContractCommissionAgent | ContractCommissionAgent | undefined;
        if (props.Agent?.id) {
            currentCommissionAgent = {
                id: props.Agent?.id,
                contractId: props.ContractId,
                commissionAgentId: props.Practitioner.practitionerUserId,
                commissionAgentName: props.GetPractiontioner(props.Practitioner.practitionerUserId)?.fullName,
                currency: Currency,
                commissionAmount: payFixValue ? FixValue : Percentage,
                contractAssociatedId: ContractId,
                haveContractAssociated: haveContractAssociated || false,
                isCommissionAPercentage: !payFixValue || false,
                onlyDoneHimSelf: onlyMadeByHimSelf || false,
                discountAlreadyPaidToSI: discountAlreadyPaidToSI || false,
                commissionAgentType: CommissionAgentTypeEnum.Practitioner
            } as ContractCommissionAgent;

            console.log('Llamando UpdateContractCommissionAgent con:', currentCommissionAgent);
            props.UpdateContractCommissionAgent(currentCommissionAgent as ContractCommissionAgent);
        }
        else {
            currentCommissionAgent = {
                contractId: props.ContractId,
                commissionAgentId: props.Practitioner.practitionerUserId,
                commissionAgentName: props.GetPractiontioner(props.Practitioner.practitionerUserId)?.fullName,
                currency: Currency,
                commissionAmount: FixValue | Percentage,
                contractAssociatedId: ContractId,
                haveContractAssociated: haveContractAssociated || false,
                isCommissionAPercentage: !payFixValue || false,
                onlyDoneHimSelf: onlyMadeByHimSelf || false,
                discountAlreadyPaidToSI: discountAlreadyPaidToSI || false,
                commissionAgentType: CommissionAgentTypeEnum.Practitioner
            } as NewContractCommissionAgent;

            props.CreateContractCommissionAgent(currentCommissionAgent as NewContractCommissionAgent);
        }
    }


    const FormFields = (
        <div className='PractitionerSettingsFormBody'>
            <section className='PractitionerSettingsSection'>
                <div className='PractitionerSettingsSectionHeader'>
                    <Text variant='mediumPlus' className='PractitionerSettingsSectionTitle'>
                        {t('contractAssociation.formValidation.selectContract', 'Debe seleccionar un contrato')}
                    </Text>
                    <Text className='PractitionerSettingsSectionDescription'>
                        {t(
                            'practitionerSettingsForm.contractAssociationHint',
                            'Active la asociacion de contrato para vincular una liquidacion existente con este profesional.'
                        )}
                    </Text>
                </div>

                <div className='PractitionerSettingsToggleRow'>
                    <Toggle
                        label={'Contrato asociado'}
                        checked={haveContractAssociated}
                        onChange={(
                            event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
                            checked?: boolean | undefined
                        ) => {
                            setHaveContractAssociated(checked || false)
                        }
                    }
                    />
                </div>

                <div className='PractitionerSettingsContractSelector'>
                    <ContractsSelectorComponent
                        onSelectedContract={
                            (contracts: Contract[]) => setContractId(contracts[0]?.id)
                        }
                        ContractsSelected={
                            props.Agent?.contractAssociatedId ? [props.Agent?.contractAssociatedId] : undefined
                        }
                        MultiselectEnable={false}
                        disabled={!haveContractAssociated}
                    />
                </div>

                <div className='PractitionerSettingsActionRow'>
                    <PrimaryButton
                        text={'Agregar contrato'}
                        onClick={openContractPanel}
                        disabled={props.isSaving || props.isUpdating || !haveContractAssociated}
                    />
                </div>
            </section>

            <Separator className='PractitionerSettingsSeparator' />

            <section className='PractitionerSettingsSection'>
                <div className='PractitionerSettingsSectionHeader'>
                    <Text variant='mediumPlus' className='PractitionerSettingsSectionTitle'>
                        {t('contractDetailPage.contractDetailItem.conceptsSettled', 'Conceptos a liquidar')}
                    </Text>
                    <Text className='PractitionerSettingsSectionDescription'>
                        {t(
                            'practitionerSettingsForm.conceptsHint',
                            'Defina los conceptos coparticipables para este profesional. Si hay contrato asociado, esta seccion queda en solo lectura.'
                        )}
                    </Text>
                </div>

                {props.Practitioner && (
                    <PractitionerConceptsListComponent
                        PractitionerId={props.Practitioner.practitionerUserId}
                        CommissionAgentId={props.Agent?.id}
                        ContractId={props.ContractId}
                        ProtocolId={props.ProtocolId}
                        disabled={haveContractAssociated}
                    />
                )}
            </section>
        </div>
    );

    // footer
    const onRenderFooterContent = () => {
        console.log('Renderizando footer - isSaving:', props.isSaving, 'isUpdating:', props.isUpdating);
        return (
            <>
                <div className='PractitionerSettingsFooter'>
                    <DefaultButton onClick={HandleCancelForm} className="OtherOption">
                        <Trans i18nKey={'conceptForm.footer.cancelButton'} />
                    </DefaultButton>
                    <PrimaryButton
                        onClick={HandleSaveForm}
                        disabled={props.isSaving || props.isUpdating}
                        className="ConfirmAction"
                    >
                        {props.isSaving || props.isUpdating ? (
                            <>
                                <Spinner size={SpinnerSize.xSmall} />&nbsp;
                                <span>{t('common.saving')}</span>
                            </>
                        ) : (
                            <Trans i18nKey={'conceptForm.footer.saveButton'} />
                        )}
                    </PrimaryButton>
                </div>
            </>
        );
    };

    const Forms = (
        <>
            <ProtocolContractFormComponent
                isOpen={isOpenContractPanel}
                Contract={undefined}
                dismissPanel={dismissContractPanel}
                openPanel={openContractPanel}
                mode=''
                RefererId={undefined}
            />
        </>
    )

    const ErrorMessage = props.error && (
        <>
            <MessageComponent
                message={'Ocurrio un error al grabar la informacion de la comisión'}
                subMessage={props.error.ErrorMessage}
                itemList={props.error.Errors}
                type={
                    MessageBarType.error
                }
            />
        </>
    );

    return (
        <Panel
            headerText={props.GetPractiontioner(props.Practitioner?.practitionerUserId)?.fullName || 'No Name'}
            type={PanelType.medium}
            isLightDismiss={true}
            isOpen={props.isOpen}
            onDismiss={props.dismissPanel}
            onRenderFooter={undefined}
            isFooterAtBottom={true}
            onRenderFooterContent={onRenderFooterContent}
            className='PractitionerSettingsPanel'
        >
            <div className='PractitionerSettingsHeaderMeta'>
                <Text className='TextDecorated'>{props.Practitioner?.studyRole?.name || 'No title'}</Text>
            </div>
            <Separator className='PractitionerSettingsSeparator' />
            <div className='PractitionerSettingsContent'>
                {ErrorMessage}
                {FormFields}
                {Forms}
            </div>
        </Panel>
    );

};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(PractitionerSettingsForm as any);

